let enRegex1;
let enRegex2;
let enRegex3;
let koRegex1;
let koRegex2;
let koRegex3;
let fallback = true;
try {
    enRegex1 = new RegExp('(?<=n)a', 'gi');
    enRegex2 = new RegExp('(?<=morn)ing', 'gi');
    enRegex3 = new RegExp('(?<=every)one', 'gi');
    koRegex1 = new RegExp('[나-낳]', 'g');
    koRegex2 = new RegExp('(다$)|(다(?= ))|(다(?=!))|(다(?=\\?))|(다(?=\\.))', 'gm');
    koRegex3 = new RegExp('(야$)|(야(?= ))|(야(?=!))|(야(?=\\?))|(야(?=\\.))', 'gm');
    fallback = false;
}
catch {
    enRegex1 = new RegExp('na', 'gi');
    enRegex2 = new RegExp('morning', 'gi');
    enRegex3 = new RegExp('everyone', 'gi');
    koRegex1 = new RegExp('[나-낳]', 'g');
    koRegex2 = new RegExp('다$', 'gm');
    koRegex3 = new RegExp('야$', 'gm');
}
function convertNormal(text) {
    return text
        .replaceAll('な', 'にゃ').replaceAll('ナ', 'ニャ').replaceAll('ﾅ', 'ﾆｬ')
        .replace(enRegex1, x => x === 'A' ? 'YA' : 'ya')
        .replace(enRegex2, x => x === 'ING' ? 'YAN' : 'yan')
        .replace(enRegex3, x => x === 'ONE' ? 'NYAN' : 'nyan')
        .replace(koRegex1, match => !isNaN(match.charCodeAt(0)) ? String.fromCharCode(match.charCodeAt(0) + '냐'.charCodeAt(0) - '나'.charCodeAt(0)) : match)
        .replace(koRegex2, '다냥')
        .replace(koRegex3, '냥');
}
function convertFallback(text) {
    return text
        .replaceAll('な', 'にゃ').replaceAll('ナ', 'ニャ').replaceAll('ﾅ', 'ﾆｬ')
        .replace(enRegex1, x => x === 'NA' ? 'NYA' : 'nya')
        .replace(enRegex2, x => x === 'MORNING' ? 'MORNYAN' : 'mornyan')
        .replace(enRegex3, x => x === 'EVERYONE' ? 'EVERYNYAN' : 'everynyan')
        .replace(koRegex1, match => String.fromCharCode(match.charCodeAt(0) + '냐'.charCodeAt(0) - '나'.charCodeAt(0)))
        .replace(koRegex2, '다냥').replaceAll('다 ', '다냥 ').replaceAll('다!', '다냥!').replaceAll('다?', '다냥?').replaceAll('다.', '다냥.')
        .replace(koRegex3, '냥').replaceAll('야 ', '냥 ').replaceAll('야!', '냥!').replaceAll('야?', '냥?').replaceAll('야.', '냥.');
}
export function nyaize(text) {
    return !fallback ? convertNormal(text) : convertFallback(text);
}
//# sourceMappingURL=nyaize.js.map